import React from 'react';

const HerbalTeaIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <radialGradient id="herbaltea-bg" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#fef9c3" />
        <stop offset="100%" stopColor="#d9f99d" />
      </radialGradient>
      <linearGradient id="herbaltea-glass" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#bef264" />
        <stop offset="100%" stopColor="#a3e635" />
      </linearGradient>
    </defs>
    <ellipse cx="32" cy="54" rx="18" ry="6" fill="#a3e635" opacity="0.18" />
    <circle cx="32" cy="24" r="20" fill="url(#herbaltea-bg)" opacity="0.18" />
    <rect
      x="20"
      y="10"
      width="24"
      height="36"
      rx="12"
      fill="url(#herbaltea-glass)"
      stroke="#fff"
      strokeWidth="2"
    />
    <rect x="24" y="14" width="16" height="28" rx="8" fill="#fef9c3" opacity="0.7" />
    <ellipse cx="32" cy="10" rx="12" ry="4" fill="#fef9c3" />
  </svg>
);

export default HerbalTeaIcon;
